<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Delete</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="modal-info mb-0">
                <img src="@/assets/images/logout_icon.webp">
            </div>
            <div class="delete_acc_txt_cl">
                <h4>Delete Account?</h4>
                <p>{{ $t('do-you-want-to-delete-account', 'Do you want to delete account') }}?</p>
            </div>
            <div class="modal-footer m-0 pb-0">
                <button @click="$emit('close')" type="button" id="closeBtn" class="thm-btn modal_cls_btn" data-bs-dismiss="modal">{{ $t('no', 'No') }}</button>
                <button @click="deleteServiceCall()" type="button" class="thm-btn modal_save_btn">{{ $t('yes', 'Yes') }}</button>
            </div>
        </div>
        
    </div>
</template>

<script>
import { removeAccount } from '../services/walletWithdraw'
export default {
    name: 'DeleteAccount',
    props: ['item'],
    emits: ['close', 'yes-click'],    
    methods:{
        async deleteServiceCall() {
            let response = await removeAccount(this.item.client_account_id)
            if(response) {
                this.$emit('yes-click');
            }
        }
    },
};
</script>